module.exports = __webpack_public_path__ + "img/maria.52fb01fd.svg";